import { Injectable } from '@angular/core';

export const STEP_UP_SIP_CONSTRAINTS = {
  monthlyInvestment: { min: 500, max: 1_000_000, step: 500 },
  stepUpPercent:     { min: 1,   max: 50,        step: 1 },
  rate:              { min: 1,   max: 30,        step: 0.1 },
  tenureYears:       { min: 1,   max: 40,        step: 1 }
} as const;

export interface StepUpSipMonthRow {
  month: number;
  installment: number;
  invested: number;
  balance: number;
}

export interface StepUpSipYearRow {
  year: number;
  installment: number;
  invested: number;
  balance: number;
  flatBalance: number;
}

export interface StepUpSipResult {
  months: StepUpSipMonthRow[];
  years: StepUpSipYearRow[];
  totalInvested: number;
  totalGain: number;
  maturityValue: number;
  flatMaturityValue: number;
  extraCorpus: number;
}

@Injectable({ providedIn: 'root' })
export class StepUpSipCalculatorService {

  calculate(monthlyInvestment: number, stepUpPercent: number, annualRate: number, tenureYears: number): StepUpSipResult {
    const i = annualRate / 100 / 12;
    const n = tenureYears * 12;

    const months: StepUpSipMonthRow[] = [];
    const flatBalances: number[] = [];
    let balance = 0;
    let invested = 0;
    let flatBalance = 0;

    for (let m = 1; m <= n; m++) {
      const yearIndex = Math.floor((m - 1) / 12);
      const installment = monthlyInvestment * Math.pow(1 + stepUpPercent / 100, yearIndex);

      balance = (balance + installment) * (1 + i);
      flatBalance = (flatBalance + monthlyInvestment) * (1 + i);
      invested += installment;

      months.push({ month: m, installment, invested, balance });
      flatBalances.push(flatBalance);
    }

    const years: StepUpSipYearRow[] = [];
    for (let y = 1; y <= tenureYears; y++) {
      const row = months[y * 12 - 1];
      years.push({
        year: y,
        installment: row.installment,
        invested: row.invested,
        balance: row.balance,
        flatBalance: flatBalances[y * 12 - 1]
      });
    }

    const maturityValue = balance;

    return {
      months,
      years,
      totalInvested: invested,
      totalGain: maturityValue - invested,
      maturityValue,
      flatMaturityValue: flatBalance,
      extraCorpus: maturityValue - flatBalance
    };
  }
}
